const defaultProperties =
{
    config    : {},
    setConfig : () => {}
};

export default defaultProperties;